import { createWithEqualityFn } from "zustand/traditional";
import {shallow} from "zustand/shallow";

interface TrackingState {
  currentPage?: string;
}

interface TrackingActions {
  setCurrentPage: (currentPage?: string) => void;
}

export const initialState: TrackingState = {
  currentPage: undefined,
}

export const useTrackingStore = createWithEqualityFn<TrackingState & TrackingActions>()(
  (set) => ({
    ...initialState,
    setCurrentPage: (currentPage?: string) => set({ currentPage }),
  }),
  shallow,
);
